import type { ConceptChipAchievement } from '@mathflat/domain/Achievement'
import type { StrengthsAndWeaknesses } from '@mathflat/domain/StudentHome'

export default class SmileChallenge {
  readonly strengths: ConceptChipAchievement | null
  readonly weaknesses: ConceptChipAchievement | null

  constructor(data: StrengthsAndWeaknesses) {
    this.strengths = data.strengths
    this.weaknesses = data.weaknesses
  }
}
